import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class downloadStatisticService {
    serviceBase = '/api/project/';
    queryString: string;

    constructor(private http: HttpClient) { }

    //getTopProjects(toolName, selectedVersion) {
    //    return this.http.get<any>(this.serviceBase + 'GetTopProject?toolName=' + toolName + '&selectedVersion=' + selectedVersion);
    //};

    //getCountries(selectedLanguage: string) {
    //    this.queryString = '/api/hometool/master?mastername=' + 'Countries' + '&selectedLanguage=' + selectedLanguage;
    //    return this.http.get<any>(this.queryString);
    //}

    //getCountryListForCountryAdmin(userName, selectedLanguage) {
    //    return this.http.get(this.serviceBase + 'CountryListForCountryAdmin?user=' + userName + '&selectedLanguage=' + selectedLanguage);
    //};

    //getTools(selectedLanguage: string) {
    //    this.queryString = '/api/tools?selectedLanguage=' + selectedLanguage;
    //    return this.http.get<any>(this.queryString);
    //};

    //getDownloadStatictics(searchProject) {
    //    return this.http.post<any>(this.serviceBase + 'DownloadStatictics', searchProject)
    //};

    //Post download excel
    //postDownloadExcel(searchCriteria, selectedLanguage) {
    //    return this.http.post<any>(this.serviceBase + 'DownloadExcelDownloadStatistics?selectedLanguage=' + selectedLanguage, searchCriteria)
    //};
}
